const resourceStatusPaths = {
  SEARCH_RESOURCE_STATUS: "",
};

export default resourceStatusPaths;
